import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Case } from '../types';

interface TeamCollaborationProps {
  caseData: Case;
  onUpdate: (updatedCase: Case) => void;
}

export const TeamCollaboration: React.FC<TeamCollaborationProps> = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6">Team Collaboration</Typography>
        <Typography variant="body2" color="text.secondary">
          Team collaboration functionality will be implemented here.
        </Typography>
      </Paper>
    </Box>
  );
};